import * as React from 'react'
import { ReactElement } from 'react'
import { Accounting, UnitDto } from '../../../context/GlobalContext'
import { EntityType } from './EntityField'
import { AccountingId } from '../../../config/finance/invoiceConfig'

type Props = {
    unit: UnitDto
    children: (tuple: DimensionFieldTuple) => ReactElement
}

export type DimensionType = EntityType.CostCenter | EntityType.CostUnit | EntityType.GLA | EntityType.Project
export type DimensionPivotValues = { [unitKey: string]: DimensionsDto }
export type DimensionsDto = {
    gla?: AccountingId
    costCenter?: AccountingId
    costUnit?: AccountingId
    project?: AccountingId
}
export type DimensionFieldTuple = [DimensionType, keyof DimensionsDto]

export const DimensionFieldMap = new Map<DimensionType, keyof DimensionsDto>([
    [EntityType.GLA, 'gla'],
    [EntityType.CostCenter, 'costCenter'],
    [EntityType.CostUnit, 'costUnit'],
    [EntityType.Project, 'project'],
])
export const SupportedDimensionMap = new Map<DimensionType, Accounting[]>([
    [EntityType.GLA, [Accounting.Exact, Accounting.Twinfield]],
    [EntityType.CostCenter, [Accounting.Exact, Accounting.Twinfield]],
    [EntityType.CostUnit, [Accounting.Exact]],
    [EntityType.Project, [Accounting.Exact, Accounting.Twinfield]],
])

export default function DimensionFields({ unit, children }: Props): ReactElement {
    return (
        <>
            {[...DimensionFieldMap.entries()]
                .filter(([dimension]: DimensionFieldTuple) =>
                    SupportedDimensionMap.get(dimension).includes(unit.accounting),
                )
                .filter(([dimension]: DimensionFieldTuple) => (unit.dimensions || []).includes(dimension))
                .map(children)}
        </>
    )
}
